(function () {
  'use strict';

  const WARRANTY_TIERS = { 1: { pct: 0.08 }, 2: { pct: 0.14 }, 4: { pct: 0.25 } };
  const WARRANTY_PRODUCT_HANDLE = 'extended-warranty';
  const PRICE_BUCKET_STEP = 50;
  const PRICE_BUCKET_MAX = 5000;
  const DEBUG = true;

  let variantLookup = null;
  let busy = false;

  const log = (...a) => { if (DEBUG) console.log('[Warranty]', ...a); };
  const money = (c) => '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const roundBucket = (p) => p <= 0 ? 0 : Math.min(Math.ceil(p / PRICE_BUCKET_STEP) * PRICE_BUCKET_STEP, PRICE_BUCKET_MAX);

  async function loadLookup() {
    if (variantLookup) return variantLookup;
    log('loading warranty variants...');
    const res = await fetch('/products/' + WARRANTY_PRODUCT_HANDLE + '.js', { credentials: 'same-origin' });
    if (!res.ok) { variantLookup = {}; return variantLookup; }
    const data = await res.json();
    variantLookup = {};
    data.variants.forEach((v) => {
      const m = (v.option1 || '').match(/(\d+)/);
      if (m) variantLookup[m[1] + '|' + v.option2] = v.id;
    });
    log('loaded', Object.keys(variantLookup).length, 'warranty variants');
    return variantLookup;
  }

  function getRoot() { return document.querySelector('[data-warranty-root]'); }
  function getSelected(root) { return root.querySelector('[data-warranty-option].is-selected'); }

  function updatePrices(root) {
    const cents = Math.round(parseFloat(root.dataset.productPrice) * 100);
    Object.keys(WARRANTY_TIERS).forEach((t) => {
      const el = root.querySelector('[data-warranty-price="' + t + '"]');
      if (el) el.textContent = money(Math.round(cents * WARRANTY_TIERS[t].pct));
    });
  }

  function bindSelection(root) {
    root.querySelectorAll('[data-warranty-option]').forEach((opt) => {
      opt.addEventListener('click', () => {
        root.querySelectorAll('[data-warranty-option]').forEach((o) => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        const r = opt.querySelector('input[type="radio"]');
        if (r) r.checked = true;
        log('selected', opt.dataset.term, 'year');
      });
    });
  }

  async function bulkAdd(form, root) {
    const fd = new FormData(form);
    const parentVariantId = parseInt(fd.get('id'), 10);
    if (!parentVariantId) throw new Error('no variant id in form');
    const quantity = parseInt(fd.get('quantity'), 10) || 1;
    const parentProps = {};
    for (const [key, value] of fd.entries()) {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m) parentProps[m[1]] = value;
    }

    const sel = getSelected(root);
    const term = parseInt(sel.dataset.term, 10);
    await loadLookup();
    const cents = Math.round(parseFloat(root.dataset.productPrice) * 100);
    const bucket = roundBucket(cents / 100);
    const vid = variantLookup[term + '|$' + bucket];
    if (!vid) throw new Error('no warranty variant for ' + term + 'yr at ' + cents);

    const now = new Date();
    const end = new Date(now);
    end.setFullYear(end.getFullYear() + term);
    const warrantyProps = {
      _warranty_term: term + ' Year',
      _warranty_parent_sku: root.dataset.productSku,
      _warranty_parent_title: root.dataset.productTitle,
      _warranty_parent_variant_id: root.dataset.productVariantId,
      _warranty_coverage_start: now.toISOString().split('T')[0],
      _warranty_coverage_end: end.toISOString().split('T')[0],
      _warranty_price_paid: money(Math.round(cents * WARRANTY_TIERS[term].pct)),
    };

    log('bulk add: parent', parentVariantId, 'x', quantity, '+ warranty', vid);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: parentVariantId, quantity: quantity, properties: parentProps },
          { id: vid, quantity: 1, properties: warrantyProps },
        ]
      })
    });

    if (!res.ok) {
      const body = await res.text();
      throw new Error('cart/add returned ' + res.status + ': ' + body);
    }
    log('bulk add ok');
  }

  async function onAtcClick(e) {
    const btn = e.target && e.target.closest && e.target.closest('[data-product-atc], button[type="submit"], input[type="submit"]');
    if (!btn) return;
    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    const root = getRoot();
    if (!root) return;
    const sel = getSelected(root);
    if (!sel || sel.dataset.term === '0') {
      log('no warranty selected, allowing default flow');
      return;
    }
    if (busy) { log('busy, skipping'); return; }
    busy = true;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    log('intercepted ATC click');

    try {
      await bulkAdd(form, root);
      window.location.href = '/cart';
    } catch (err) {
      console.error('[Warranty] error:', err);
      busy = false;
      log('falling back to normal submit');
      form.submit();
    }
  }

  function init() {
    const root = getRoot();
    if (!root) { log('no warranty selector on page'); return; }
    updatePrices(root);
    bindSelection(root);
    document.addEventListener('click', onAtcClick, true);
    log('initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();